import React, { useEffect, useState } from "react";
import Action from "../../components/common/Action";
import DebounceSearch from "../../components/common/DebounceSearch";
import CustomTable from "../../components/customtable/CustomTable";
import { useDispatch } from "react-redux";
import Breadcrumb from "../../components/common/Breadcrumb";
import { useSelector } from "react-redux";
import { editUserTester, getUserTesterlist } from "../../redux/tester/slice";
import EditUserTester from "./EditUserTester";

const UserTester = () => {
  const dispatch = useDispatch();
  const [searchValue, setSearchValue] = useState("");
  const [pageLimit, setPageLimit] = useState(10);
  const [pageCount, setPageCount] = useState(1);
  const [sortBy, setSortBy] = useState("");
  const [sortDirection, setSortDirection] = useState("desc");
  const [isLoading, setIsLoading] = useState(false);
  const [ismodelOpen, setIsmodelOpen] = useState(false);

  // selector
  const { UserTesterList, UserTesterListLoading } = useSelector((store) => ({
    UserTesterList: store?.userTesterData?.getUserTesterlistStatus?.data?.data,
    UserTesterListLoading: store?.userTesterData?.loading,
  }));

  const getUserfatch = () => {
    dispatch(
      getUserTesterlist({
        search: searchValue,
        pageCount: pageCount,
        pageLimit: pageLimit,
        sort_by: sortBy,
        sort_direction: sortDirection === "asc" ? "asc" : "desc",
      }),
    );
  };

  useEffect(() => {
    getUserfatch();
  }, [dispatch, searchValue, pageCount, pageLimit, sortBy, sortDirection]);

  const revertPaid = async (tester) => {
    setIsLoading(true);
    const payload = {
      email: tester.email,
      isFreeUser: false,
    };
    try {
      const res = await dispatch(editUserTester(payload));
      if (res.type === "editUserTester/fulfilled") {
        dispatch(
          getUserTesterlist({
            search: searchValue,
            pageCount: pageCount,
            pageLimit: pageLimit,
            sort_by: sortBy,
            sort_direction: sortDirection === "asc" ? "asc" : "desc",
          }),
        );
      }
    } finally {
      setIsLoading(false);
    }
  };

  // Table Headers
  const ColumnHeaders = () => (
    <>
      <th className="w-24 table-th">No.</th>
      <th className="table-th">Email</th>
      <th className="table-th">Registered</th>
      <th className="w-24 table-th">Actions</th>
    </>
  );

  // Table Rows
  const DataRows = () => (
    <>
      {(UserTesterList?.data || []).map((item, index) => (
        <tr key={item.id} className="shadow-sm text-mgrey hover:bg-navTheme/5">
          <td className="px-5 py-3">
            {(pageCount - 1) * pageLimit + index + 1}
          </td>
          <td className="px-5 py-3">
            <div className="line-clamp-1">{item?.email || "-"}</div>
          </td>
          <td className="px-5 py-3">
            <div
              className={`line-clamp-1 ${
                item?.isRegistered ? "text-green-700" : "text-red"
              }`}
            >
              {item?.isRegistered ? "Registered" : "Not Registered"}
            </div>
          </td>
          <td className="px-5 py-3 text-start">
            <div className="flex justify-start">
              <Action
                optionList={
                  <>
                    <li
                      className="flex gap-2 items-center px-6 py-2 bg-white hover:bg-hoverTheme transition duration-300 cursor-pointer"
                      onClick={() => revertPaid(item)}
                    >
                      Revert Paid
                    </li>
                  </>
                }
              />
            </div>
          </td>
        </tr>
      ))}
    </>
  );

  return (
    <>
      <div className="space-y-5">
        <div>
          <h6 className="font-Montserrat font-medium text-xl mb-3">
            Manage Free Users
          </h6>
          <Breadcrumb
            breadCrumbParent={"Home"}
            breadCrumbActive={"Manage Free Users"}
            breadCrumbParent3={"Subscription"}
            breadCrumbTitleKey={"/"}
          />
        </div>
        <div className="flex items-center space-x-4 w-full">
          <DebounceSearch
            className="full-width"
            search={searchValue}
            handleChange={setSearchValue}
            placeholder={"Search..."}
          />
          <button
            className="bg-themeBtn text-white flex items-center justify-center px-2 py-[9px] rounded uppercase font-figtree text-base w-60 shadow-[0_4px_6px_rgba(0,0,0,0.3)]"
            onClick={() => {
              setIsmodelOpen(true);
            }}
            type="button"
          >
            + Make User Free
          </button>
        </div>

        <div className="w-full bg-white shadow rounded-lg">
          <CustomTable
            overflowVisibleLg={true}
            columnHeaders={<ColumnHeaders />}
            dataRows={<DataRows />}
            data={UserTesterList}
            loading={UserTesterListLoading}
            showPagination={true}
            disableNext={!!UserTesterList?.data?.length}
            disablePrev={!!UserTesterList?.data?.length}
            setPaginationCurrentLimit={setPageLimit}
            paginationCurrentLimit={pageLimit}
            current={pageCount}
            total={UserTesterList?.pagination?.total}
            paginationData={(crPage) => setPageCount(crPage)}
            lastPage={Math.ceil(UserTesterList?.pagination?.total / pageLimit)}
          />
        </div>
      </div>
      {ismodelOpen && (
        <div>
          <EditUserTester
            onClose={() => setIsmodelOpen(false)}
            getUserfatch={getUserfatch}
          />
        </div>
      )}
    </>
  );
};

export default UserTester;
